import "./FeaturesGrid.css";
import liquidAsset from "../../assets/liquid-center.png";

// ── Small grid cell icons ────────────────────────────────────────────────────
const icons = {
  ai: () => (
    <svg stroke="currentColor" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09Z" />
    </svg>
  ),
  chat: () => (
    <svg stroke="currentColor" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z" />
    </svg>
  ),
  knowledge: () => (
    <svg stroke="currentColor" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25" />
    </svg>
  ),
  workflow: () => (
    <svg stroke="currentColor" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
    </svg>
  ),
  analytics: () => (
    <svg stroke="currentColor" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3" />
    </svg>
  ),
  inbox: () => (
    <svg stroke="currentColor" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H6.911a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661Z" />
    </svg>
  ),
  link: () => (
    <svg stroke="currentColor" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
    </svg>
  ),
  team: () => (
    <svg stroke="currentColor" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
    </svg>
  ),
  approval: () => (
    <svg stroke="currentColor" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25Z" />
    </svg>
  ),
  training: () => (
    <svg stroke="currentColor" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 3.741-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5" />
    </svg>
  ),
  handoff: () => (
    <svg stroke="currentColor" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" />
    </svg>
  ),
  widget: () => (
    <svg stroke="currentColor" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z" />
    </svg>
  ),
  api: () => (
    <svg stroke="currentColor" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5" />
    </svg>
  ),
  multilingual: () => (
    <svg stroke="currentColor" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="m10.5 21 5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.255m-4.589 8.495a18.023 18.023 0 0 1-3.827-5.802" />
    </svg>
  ),
  security: () => (
    <svg stroke="currentColor" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
    </svg>
  ),
  clock: () => (
    <svg stroke="currentColor" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
    </svg>
  ),
  search: () => (
    <svg stroke="currentColor" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
    </svg>
  ),
  database: () => (
    <svg stroke="currentColor" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
    </svg>
  ),
  notification: () => (
    <svg stroke="currentColor" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
    </svg>
  ),
  key: () => (
    <svg stroke="currentColor" fill="none" strokeWidth="1.5" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z" />
    </svg>
  ),
};

// Small grid cells
const gridItems = [
  { icon: "ai", label: "AI Responses" },
  { icon: "knowledge", label: "Knowledge Sync" },
  { icon: "multilingual", label: "50+ Languages" },
  { icon: "widget", label: "Chat Widget" },
  { icon: "handoff", label: "Human Handoff" },
  { icon: "api", label: "REST API" },
  { icon: "team", label: "Team Roles" },
  { icon: "search", label: "Semantic Search" },
  { icon: "inbox", label: "Unified Inbox" },
  { icon: "training", label: "Custom Training" },
  { icon: "workflow", label: "Automation Rules" },
  { icon: "database", label: "Multi-Source RAG" },
  { icon: "notification", label: "Alert Triggers" },
  { icon: "clock", label: "24/7 Coverage" },
  { icon: "approval", label: "Approval Flows" },
  { icon: "analytics", label: "Analytics Dash" },
  { icon: "link", label: "Link Tracking" },
  { icon: "security", label: "Access Controls" },
  { icon: "key", label: "Workspace Auth" },
  { icon: "chat", label: "Saved Replies" },
];

// Featured cards — pastel glow + coloured icon badges (FeedHive-style)
const featuredCards = [
  { id: "tl", col: "4 / span 2", row: "3 / span 2", roundedExtra: "fg-card-br" },
  { id: "tr", col: "6 / span 2", row: "3 / span 2", roundedExtra: "fg-card-bl" },
  { id: "bl", col: "4 / span 2", row: "5 / span 2", roundedExtra: "fg-card-tr" },
  { id: "br", col: "6 / span 2", row: "5 / span 2", roundedExtra: "fg-card-tl" },
];

export default function FeaturesGrid() {
  return (
    <section className="fg-section" id="features" aria-labelledby="fg-heading">
      <div className="fg-container">

        {/* ── Header ── */}
        {/* <div className="fg-header">
          <p className="fg-eyebrow">Features</p>
          <h2 id="fg-heading" className="fg-heading">
            The infrastructure serious support teams run on.
          </h2>
        </div> */}

        {/* ── Mobile card layout ── */}
        <div className="fg-mobile-grid" aria-hidden="true">
          <div className="fg-mobile-marquee-container">
            <div className="fg-mobile-marquee-row row-1">
              {[...gridItems.slice(0, 10), ...gridItems.slice(0, 10)].map((item, idx) => {
                const Icon = icons[item.icon as keyof typeof icons];
                return <div className="fg-chip" key={`r1-${idx}`}><Icon /><span>{item.label}</span></div>;
              })}
            </div>
            <div className="fg-mobile-marquee-row row-2">
              {[...gridItems.slice(10, 20), ...gridItems.slice(10, 20)].map((item, idx) => {
                const Icon = icons[item.icon as keyof typeof icons];
                return <div className="fg-chip" key={`r2-${idx}`}><Icon /><span>{item.label}</span></div>;
              })}
            </div>
            <div className="fg-mobile-marquee-row row-3">
              {[...gridItems.slice(5, 15), ...gridItems.slice(5, 15)].map((item, idx) => {
                const Icon = icons[item.icon as keyof typeof icons];
                return <div className="fg-chip" key={`r3-${idx}`}><Icon /><span>{item.label}</span></div>;
              })}
            </div>
            <div className="fg-mobile-marquee-row row-4">
              {[...gridItems.slice(15, 20), ...gridItems.slice(0, 5), ...gridItems.slice(15, 20), ...gridItems.slice(0, 5)].map((item, idx) => {
                const Icon = icons[item.icon as keyof typeof icons];
                return <div className="fg-chip" key={`r4-${idx}`}><Icon /><span>{item.label}</span></div>;
              })}
            </div>
            <div className="fg-mobile-marquee-row row-5">
              {[...gridItems.slice(2, 12), ...gridItems.slice(2, 12)].map((item, idx) => {
                const Icon = icons[item.icon as keyof typeof icons];
                return <div className="fg-chip" key={`r5-${idx}`}><Icon /><span>{item.label}</span></div>;
              })}
            </div>
            <div className="fg-mobile-marquee-row row-6">
              {[...gridItems.slice(12, 20), ...gridItems.slice(0, 2), ...gridItems.slice(12, 20), ...gridItems.slice(0, 2)].map((item, idx) => {
                const Icon = icons[item.icon as keyof typeof icons];
                return <div className="fg-chip" key={`r6-${idx}`}><Icon /><span>{item.label}</span></div>;
              })}
            </div>
          </div>
          <div className="fg-mobile-center-asset">
            <div className="fg-center-asset-wrap" aria-hidden="true">
              <img src={liquidAsset} alt="" className="fg-center-asset fg-mobile-asset" />
            </div>
            <div className="fg-floating-text-wrap fg-mobile-text-wrap">
              {[
                { id: "agentic", text: "Agentic." },
                { id: "contextual", text: "Contextual." },
                { id: "live", text: "Live." },
                { id: "knowledge", text: "Intelligent." },
              ].map((word) => (
                <div key={`mob-${word.id}`} className="fg-word-pair" id={`fg-word-mob-${word.id}`}>
                  <span className="fg-floating-word-half left">{word.text}</span>
                  <span className="fg-floating-word-half right">{word.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Desktop bento grid ── */}
        <div className="fg-desktop-wrap" aria-label="Features grid">
          {/* Edge fade overlays */}
          <div className="fg-fade fg-fade-left" aria-hidden="true" />
          <div className="fg-fade fg-fade-right" aria-hidden="true" />
          <div className="fg-fade fg-fade-top" aria-hidden="true" />
          <div className="fg-fade fg-fade-bottom" aria-hidden="true" />

          <div className="fg-desktop-grid">
            {/* Padding rows (top + bottom)
            {Array.from({ length: 10 }).map((_, i) => (
              <div key={`top-${i}`} className="fg-pad-cell" style={{ gridColumn: `${i + 1} / span 1`, gridRow: "1 / span 1" }} aria-hidden="true" />
            ))} */}
            {/* {Array.from({ length: 10 }).map((_, i) => (
              <div key={`bot-${i}`} className="fg-pad-cell" style={{ gridColumn: `${i + 1} / span 1`, gridRow: "8 / span 1" }} aria-hidden="true" />
            ))} */}

            {/* Small feature cells — left block (cols 1-3) rows 2-7 */}
            {[
              { col: 1, row: 2, icon: "ai", label: "AI Responses" },
              { col: 2, row: 2, icon: "knowledge", label: "Knowledge Sync" },
              { col: 3, row: 2, icon: "multilingual", label: "50+ Languages" },
              { col: 1, row: 3, icon: "widget", label: "Chat Widget" },
              { col: 2, row: 3, icon: "handoff", label: "Human Handoff" },
              { col: 3, row: 3, icon: "api", label: "REST API" },
              { col: 1, row: 4, icon: "team", label: "Team Roles" },
              { col: 2, row: 4, icon: "search", label: "Semantic Search" },
              { col: 3, row: 4, icon: "inbox", label: "Unified Inbox" },
              { col: 1, row: 5, icon: "training", label: "Custom Training" },
              { col: 2, row: 5, icon: "workflow", label: "Automation Rules" },
              { col: 3, row: 5, icon: "database", label: "Multi-Source RAG" },
              { col: 1, row: 6, icon: "notification", label: "Alert Triggers" },
              { col: 2, row: 6, icon: "clock", label: "24/7 Coverage" },
              { col: 3, row: 6, icon: "approval", label: "Approval Flows" },
              { col: 1, row: 7, icon: "analytics", label: "Analytics Dash" },
              { col: 2, row: 7, icon: "link", label: "Link Tracking" },
              { col: 3, row: 7, icon: "security", label: "Access Controls" },
              // Center edge rows — fill cols 4-7 in rows 2 & 7 so no gray bleeds through
              { col: 4, row: 2, icon: "chat", label: "AI Captions" },
              { col: 5, row: 2, icon: "widget", label: "Custom Widget" },
              { col: 6, row: 2, icon: "handoff", label: "Live Handoff" },
              { col: 7, row: 2, icon: "inbox", label: "Omni-Inbox" },
              { col: 4, row: 7, icon: "api", label: "Zapier / Make" },
              { col: 5, row: 7, icon: "workflow", label: "Auto-Escalate" },
              { col: 6, row: 7, icon: "training", label: "Q&A Training" },
              { col: 7, row: 7, icon: "analytics", label: "CSAT Tracking" },
            ].map(({ col, row, icon, label }) => {
              const Icon = icons[icon as keyof typeof icons];
              return (
                <div
                  key={`l-${col}-${row}`}
                  className="fg-cell"
                  style={{ gridColumn: `${col} / span 1`, gridRow: `${row} / span 1` }}
                >
                  <Icon />
                  <span>{label}</span>
                </div>
              );
            })}

            {/* Small feature cells — right block (cols 8-10) rows 2-7 */}
            {[
              { col: 8, row: 2, icon: "key", label: "Workspace Auth" },
              { col: 9, row: 2, icon: "chat", label: "Saved Replies" },
              { col: 10, row: 2, icon: "widget", label: "Embed Widget" },
              { col: 8, row: 3, icon: "team", label: "Visitor Persona" },
              { col: 9, row: 3, icon: "approval", label: "Content Scoring" },
              { col: 10, row: 3, icon: "notification", label: "Slack Alerts" },
              { col: 8, row: 4, icon: "analytics", label: "Perf Stats" },
              { col: 9, row: 4, icon: "clock", label: "Best Time Slots" },
              { col: 10, row: 4, icon: "search", label: "Fuzzy Search" },
              { col: 8, row: 5, icon: "multilingual", label: "Language Detect" },
              { col: 9, row: 5, icon: "database", label: "Vector Store" },
              { col: 10, row: 5, icon: "security", label: "Data Encryption" },
              { col: 8, row: 6, icon: "api", label: "Webhooks" },
              { col: 9, row: 6, icon: "handoff", label: "Live Takeover" },
              { col: 10, row: 6, icon: "inbox", label: "Social Inbox" },
              { col: 8, row: 7, icon: "workflow", label: "Bulk Actions" },
              { col: 9, row: 7, icon: "training", label: "Fine-Tuning" },
              { col: 10, row: 7, icon: "link", label: "UTM Tracking" },
            ].map(({ col, row, icon, label }) => {
              const Icon = icons[icon as keyof typeof icons];
              return (
                <div
                  key={`r-${col}-${row}`}
                  className="fg-cell"
                  style={{ gridColumn: `${col} / span 1`, gridRow: `${row} / span 1` }}
                >
                  <Icon />
                  <span>{label}</span>
                </div>
              );
            })}

            {/* ── Separate Background Tiles for the "Sandwich" effect ── */}
            <div className="fg-card-bg fg-card-br" style={{ gridColumn: "4 / span 2", gridRow: "3 / span 2" }} aria-hidden="true" />
            <div className="fg-card-bg fg-card-bl" style={{ gridColumn: "6 / span 2", gridRow: "3 / span 2" }} aria-hidden="true" />
            <div className="fg-card-bg fg-card-tr" style={{ gridColumn: "4 / span 2", gridRow: "5 / span 2" }} aria-hidden="true" />
            <div className="fg-card-bg fg-card-tl" style={{ gridColumn: "6 / span 2", gridRow: "5 / span 2" }} aria-hidden="true" />

            {/* ── Central "All in One" 3D Asset (Middle Layer) ── */}
            <div className="fg-center-asset-wrap" aria-hidden="true">
              <img src={liquidAsset} alt="" className="fg-center-asset" />
            </div>

            {/* ── Spanning Typography (Top Layer) ── */}
            <div className="fg-floating-text-wrap">
              {[
                { id: "agentic", text: "Agentic." },
                { id: "contextual", text: "Contextual." },
                { id: "live", text: "Live." },
                { id: "knowledge", text: "Intelligent." },
              ].map((word) => (
                <div key={word.id} className="fg-word-pair" id={`fg-word-${word.id}`}>
                  <span className="fg-floating-word-half left">{word.text}</span>
                  <span className="fg-floating-word-half right">{word.text}</span>
                </div>
              ))}
            </div>

            {/* ── Four background cards (Bottom Layer) ── */}
            {featuredCards.map((card) => (
              <article
                key={card.id}
                className={`fg-card ${card.roundedExtra}`}
                style={{ gridColumn: card.col, gridRow: card.row }}
              >
                <div className="fg-card-body" />
              </article>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
